import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { StorageManagerService, AuthorizationService } from '../../shared/services/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
    public loggedIn = false;
    private subscription: Subscription;
    user: any;
    userName: string;

    constructor(private authenticationService: AuthenticationService,
        private authorizationService: AuthorizationService,
        private storageManagerService: StorageManagerService,
      private router: Router, private toastr: ToastrService) {

    }

    login() {
        this.authenticationService.login();
    }

    ngOnInit() {
        this.subscription = this.authenticationService.getIsAuthorized().subscribe(
            (isAuthorized: boolean) => {
                this.loggedIn = isAuthorized;

                if (this.storageManagerService.read('userData')) {

                    this.userName = this.storageManagerService.read('userData').name;

                    this.setUserName(this.userName);
                }

          },
          error => {
            this.toastr.error(error.message);
          });
    }

    setUserName(data) {

        this.userName = data;
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
